import {Component} from '@angular/core';
import {RouterModule} from '@angular/router';
import {WaButtonDirective} from 'angular-awesome';
import {WaCardDirective} from 'angular-awesome';
import {WaTextDirective} from 'angular-awesome';
import {WaTagDirective} from 'angular-awesome';
import {WaDividerDirective} from 'angular-awesome';
import {MarkdownComponent} from 'ngx-markdown';
@Component({
	selector:'jwebmp-plugin-client',
	templateUrl:'./ClientPluginPage.html',
	styles: [],
	styleUrls:['./ClientPluginPage.scss'
],
	viewProviders:[],
	animations:[],
	providers:[],
	schemas:[],
	preserveWhitespaces:true,
	host:{},
	imports:[
		RouterModule,
		WaButtonDirective,
		WaCardDirective,
		WaTextDirective,
		WaTagDirective,
		WaDividerDirective,
		MarkdownComponent,
],
	standalone:true
})
export class ClientPluginPage
{
	mdContent_79 = `\`\`\`xml
<dependency>
  <groupId>com.jwebmp</groupId>
  <artifactId>jwebmp-client</artifactId>
</dependency>
\`\`\``;
	mdContent_80 = `\`\`\`kotlin
implementation("com.jwebmp:jwebmp-client:2.0.0-SNAPSHOT")
\`\`\``;
	mdContent_81 = `\`\`\`java
public class MyPageConfigurator
        implements IPageConfigurator<MyPageConfigurator> {
    @Override
    public IPage<?> configure(IPage<?> page) {
        // add CSS/JS references, configure body children
        return page;
    }
    @Override
    public Integer sortOrder() { return 500; }
}
\`\`\``;
	mdContent_82 = `\`\`\`java
public class MyPageConfigurator
        implements IPageConfigurator<MyPageConfigurator> {
    @Override
    public IPage<?> configure(IPage<?> page) {
        // add CSS/JS references, configure body children
        return page;
    }
    @Override
    public Integer sortOrder() { return 100; }
}
\`\`\``;
}
